var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7593 16.5942L13.973 12.807C16.4583 9.70494 16.3794 5.1929 13.5104 2.31742L13.504 2.31102C10.4232 -0.770339 5.40416 -0.770339 2.31058 2.31102C-0.770195 5.39877 -0.770195 10.4251 2.31058 13.5129C3.85748 15.0535 5.87913 15.824 7.90717 15.824C9.6621 15.824 11.361 15.1336 12.8042 13.9752L16.5911 17.7626C16.7515 17.923 16.9633 18 17.1751 18C17.3869 18 17.5987 17.923 17.7593 17.7626C18.0802 17.4415 18.0802 16.9151 17.7593 16.5942ZM3.4787 12.3446C1.02687 9.89867 1.02687 5.92524 3.4787 3.47935C4.69822 2.25321 6.30269 1.64333 7.90717 1.64333C9.51164 1.64333 11.1227 2.25321 12.3423 3.47935C14.7866 5.92391 14.7866 9.90198 12.3511 12.3408C12.3487 12.3432 12.3447 12.3419 12.3423 12.3443C12.3407 12.3459 12.3414 12.3488 12.3398 12.3503C9.88734 14.7955 5.91531 14.7942 3.4787 12.3446Z",
    fill: "#A59F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.4d8317fbbcb5c0781d85d390a0c2a62c.svg";
export { ForwardRef as ReactComponent };